import errorIcon from "$assets/images/error-page.svg?url";
import type { ComponentProps, FC } from "react";

/** The branded error illustration. Plain <img>, so it renders without any contexts. */
export const StethoscopeImage: FC<ComponentProps<"img">> = (props) => (
  <img
    alt="A tangled stethoscope indicating a problem has occurred"
    src={errorIcon}
    {...props}
  />
);
